/**
 * Phone handling for the kiosk. US screening event, so we assume +1 and
 * validate loosely — the goal is to catch a fat-fingered entry at the kiosk, not
 * to reimplement libphonenumber. The edge function validates again before it
 * hands anything to Twilio.
 */

/** Digits only, capped at a sane length. */
export function digitsOf(input: string): string {
  return input.replace(/\D/g, '').slice(0, 11);
}

/** (555) 555-5555 as the guest types. */
export function formatUsPhone(input: string): string {
  const d = digitsOf(input).replace(/^1/, '');
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
}

export function isValidUsPhone(input: string): boolean {
  const d = digitsOf(input).replace(/^1/, '');
  if (d.length !== 10) return false;
  // NANP: area code and exchange cannot start with 0 or 1.
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(d);
}

/** E.164 for Twilio. Returns null when the input is not usable. */
export function toE164(input: string): string | null {
  if (!isValidUsPhone(input)) return null;
  const d = digitsOf(input).replace(/^1/, '');
  return `+1${d}`;
}

/** For diagnostics and logs — never store or display a full number. */
export function maskPhone(e164: string): string {
  return e164.length > 4 ? `${'•'.repeat(e164.length - 4)}${e164.slice(-4)}` : '••••';
}
